import { mergeStyleSets, getScreenSelector, ScreenWidthMinMedium, ScreenWidthMaxMedium, ScreenWidthMinLarge } from '@fluentui/react';

function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
var _obj;
var styles = mergeStyleSets({
    container: {
        position: 'relative'
    },
    button: {
        position: 'absolute',
        top: 0,
        right: 0,
        minWidth: 'unset',
        width: 32,
        height: 32
    },
    checkbox: {
        padding: 8
    },
    searchbarContainer: {
        position: 'relative'
    },
    icon: {
        marginRight: 32
    },
    hidden: {
        visibility: 'hidden'
    },
    displayNone: {
        display: 'none'
    },
    callout: (_obj = {
        width: 'calc(100vw - 16px)'
    }, _define_property(_obj, getScreenSelector(ScreenWidthMinMedium, ScreenWidthMaxMedium), {
        width: 'calc(100vw - 32px)'
    }), _define_property(_obj, getScreenSelector(ScreenWidthMinLarge, undefined), {
        width: '100%'
    }), _obj),
    focusZone: {
        padding: 4
    },
    dropdown: {
        height: '100%',
        minWidth: 76,
        maxWidth: 164
    },
    dropdownText: {
        textOverflow: 'ellipsis',
        whiteSpace: 'nowrap',
        overflow: 'hidden',
        margin: '0px 4px'
    }
});

export { styles };
